export default "/images/b6da7c880e7b6948fad791fe97b760a2.png";